import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import main from './Main'
import user from './User'
import info from './Info'
import {
  getUserCreatedEventsReducer,
  getUserCreatedInfosReducer,
  getUserCreatedProductsReducer,
  createEventMinaReducer,
  createInfoMinaReducer,
  createProductReducer,
  getNotificationReducer,
  getFavoriteProductsReducer,
  getFavoriteEventsReducer,
  getFavoriteInfosReducer,
} from './Profile'
import {
  getEventListsReducer,
  getSubeventListsReducer,
  getEventPromotedReducer,
  getEventDetailReducer,
  getEventFilterReducer,
  getEventCategoriesReducer,
  getOtherEventsReducer,
  likedEventsReducer,
} from './Event'
import home from './Home'
import category from './Category'
import product from './Product'
import search from './Search'
import shop from './Shop'
import inbox from './Inbox'

export default combineReducers({
  routing: routerReducer,
  main,
  user,
  info,
  eventDetail: getEventDetailReducer,
  eventFilter: getEventFilterReducer,
  eventLists: getEventListsReducer,
  subeventLists: getSubeventListsReducer,
  eventPromoted: getEventPromotedReducer,
  eventCategories: getEventCategoriesReducer,
  otherEvents: getOtherEventsReducer,
  likedEvents: likedEventsReducer,
  notification: getNotificationReducer,
  // Profile
  eventsCategory: getUserCreatedEventsReducer,
  infoCategory: getUserCreatedInfosReducer,
  pasarCategory: getUserCreatedProductsReducer,
  createEvent: createEventMinaReducer,
  createInfo: createInfoMinaReducer,
  createProduct: createProductReducer,
  // Favorite
  favoriteProducts: getFavoriteProductsReducer,
  favoriteEvents: getFavoriteEventsReducer,
  favoriteInfos: getFavoriteInfosReducer,
  home,
  category,
  product,
  search,
  shop,
  inbox,
})



// WEBPACK FOOTER //
// ./src/modules/index.js